/**
 * The purpose of this package is to give webpack hints to all language
 * files for each xinglet.
 * The `webpackChunkName` is required to split a chunk per language and
 * the name 'hops-language-[request]' is used in the metadata-plugin
 * to identify the language chunks.
 *
 * Since we don't have the language set here, we guard the code, so it is
 * not executed. The only matter is to add the files to the webpack
 * compilation.
 */
if (typeof language !== 'undefined') {
  // add all i18n files to the webpack bundle
  import(
    // eslint-disable-next-line no-undef
    /* webpackChunkName: "hops-language-[request]" */ `locales/${language}`
  );
}
